import { render, staticRenderFns } from "./partner.vue?vue&type=template&id=0b8508a4&scoped=true&"
import script from "./partner.vue?vue&type=script&lang=js&"
export * from "./partner.vue?vue&type=script&lang=js&"
import style0 from "./partner.vue?vue&type=style&index=0&id=0b8508a4&scoped=true&lang=css&"
import style1 from "./partner.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8508a4",
  null
  
)

export default component.exports